// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2bX4i","content":"LayoutSettings_content__1Q4BV"};